import styled from 'styled-components';

export const Header = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: normal;
	align-content: normal;
	padding-bottom: 1rem;
`;

export const HeaderTitle = styled.h1`
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: auto;
	align-self: auto;
	order: 0;
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: normal;
`;

export const HeaderCloseBtn = styled.button`
	display: block;
	flex-grow: 0;
	flex-shrink: 1;
	flex-basis: auto;
	align-self: auto;
	order: 0;
	border: none;
	background: transparent;
	font-size: large;
`;
